import { jsxs as v, jsx as r, Fragment as V } from "react/jsx-runtime";
import A, { useState as I, useRef as y, useEffect as ee } from "react";
import { useFoundation as K, createComponent as ne, useId as oe, useClassNames as Q, Tag as N, mergeRefs as J } from "@rmwc/base";
import { FloatingLabel as de } from "@rmwc/floating-label";
import { Icon as ce } from "@rmwc/icon";
import { LineRipple as se } from "@rmwc/line-ripple";
import { NotchedOutline as ue } from "@rmwc/notched-outline";
import { withRipple as fe } from "@rmwc/ripple";
import { MDCTextFieldCharacterCounterFoundation as me, MDCTextFieldFoundation as xe, MDCTextFieldIconFoundation as he } from "@material/textfield";
const ge = (n) => {
  const [t, l] = I(), { foundation: i, ...c } = K({
    props: n,
    api: ({
      foundation: o
    }) => ({
      getFoundation: () => o
    }),
    elements: {},
    foundation: () => new me({
      setContent: (o) => {
        l(o);
      }
    })
  });
  return {
    content: t,
    ...c
  };
}, pe = (n) => {
  const [t, l] = I(!1), [i, c] = I(0), [o, a] = I(), [m, F] = I(!1), [h, W] = I(!1), s = y(), w = (d) => {
    s.current = d;
  }, g = y(), R = (d) => g.current = d, p = y(), b = (d) => p.current = d, H = y(), U = (d) => H.current = d, { content: X } = ge({
    apiRef: n.characterCount ? w : void 0
  }), { foundation: x, ...M } = K({
    props: n,
    elements: { rootEl: !0, inputEl: !0 },
    foundation: ({ rootEl: d, inputEl: f, getProps: L }) => {
      const _ = () => ({
        shakeLabel: (e) => F(e),
        floatLabel: (e) => {
          W(L().floatLabel ?? e);
        },
        hasLabel: () => !!L().label,
        getLabelWidth: () => {
          var e;
          return ((e = H.current) == null ? void 0 : e.getWidth()) || 0;
        }
      }), P = () => ({
        activateLineRipple: () => {
          l(!0);
        },
        deactivateLineRipple: () => {
          l(!1);
        },
        setLineRippleTransformOrigin: (e) => {
          c(e);
        }
      }), j = () => ({
        notchOutline: (e) => {
          a(e);
        },
        closeOutline: () => {
          L().floatLabel ?? a(void 0);
        },
        hasOutline: () => !!L().outlined
      }), D = () => ({
        registerInputInteractionHandler: (e, u) => f.addEventListener(e, u),
        deregisterInputInteractionHandler: (e, u) => f.removeEventListener(e, u),
        getNativeInput: () => f.ref
      }), z = () => ({
        characterCounter: s.current ? s.current.getFoundation() : void 0,
        helperText: void 0,
        leadingIcon: g.current ? g.current.getFoundation() : void 0,
        trailingIcon: p.current ? p.current.getFoundation() : void 0
      });
      return new xe(
        {
          addClass: (e) => d.addClass(e),
          removeClass: (e) => d.removeClass(e),
          hasClass: (e) => d.hasClass(e),
          registerTextFieldInteractionHandler: (e, u) => d.addEventListener(e, u),
          deregisterTextFieldInteractionHandler: (e, u) => d.removeEventListener(e, u),
          registerValidationAttributeChangeHandler: (e) => {
            const u = (C) => C.map((T) => T.attributeName);
            if (f.ref) {
              const C = new MutationObserver(
                (Y) => e(u(Y))
              ), T = f.ref, E = { attributes: !0 };
              return T && C.observe(T, E), C;
            }
            return {};
          },
          deregisterValidationAttributeChangeHandler: (e) => {
            e && e.disconnect();
          },
          isFocused: () => document.activeElement === f.ref,
          ...D(),
          ..._(),
          ...P(),
          ...j()
        },
        z()
      );
    }
  }), O = x.getValue();
  return ee(() => {
    n.value !== void 0 && n.value !== O && x.setValue(String(n.value));
  }, [n.value, x, O]), ee(() => {
    n.floatLabel !== void 0 && (x.notchOutline(n.floatLabel), x.adapter.floatLabel(n.floatLabel));
  }, [x, n.floatLabel]), {
    shakeLabel: m,
    floatLabel: h,
    notchWidth: o,
    lineRippleActive: t,
    lineRippleCenter: i,
    setCharacterCounter: w,
    setLeadingIcon: R,
    setTrailingIcon: b,
    setFloatingLabel: U,
    characterCountContent: X,
    ...M
  };
}, be = (n) => {
  const { foundation: t, ...l } = K({
    props: n,
    elements: { rootEl: !0 },
    api: ({
      foundation: i
    }) => ({
      getFoundation: () => i
    }),
    foundation: ({ rootEl: i, emit: c }) => new he({
      getAttr: (a) => i.getProp(a),
      setAttr: (a, m) => i.setProp(a, m),
      removeAttr: (a) => i.removeProp(a),
      setContent: (a) => {
        i.setProp("icon", a);
      },
      registerInteractionHandler: (a, m) => i.addEventListener(a, m),
      deregisterInteractionHandler: (a, m) => i.removeEventListener(a, m),
      notifyIconAction: () => c("onClick", {}, !0)
    })
  });
  return { ...l };
}, Oe = ne(
  function(t, l) {
    const {
      label: i,
      style: c,
      outlined: o,
      align: a,
      invalid: m,
      disabled: F,
      helpText: h,
      children: W,
      textarea: s,
      fullwidth: w,
      inputRef: g,
      characterCount: R,
      icon: p,
      trailingIcon: b,
      rootProps: H = {},
      foundationRef: U,
      ripple: X,
      prefix: x,
      suffix: M,
      resizeable: O,
      floatLabel: d,
      ...f
    } = t, {
      rootEl: L,
      inputEl: _,
      shakeLabel: P,
      floatLabel: j,
      notchWidth: D,
      lineRippleActive: z,
      lineRippleCenter: e,
      setLeadingIcon: u,
      setTrailingIcon: C,
      setFloatingLabel: T,
      characterCountContent: E
    } = pe(t), Z = oe("textfield", t) + "-label", ae = Q(t, [
      "mdc-text-field",
      "mdc-text-field--upgraded",
      {
        "mdc-text-field--filled": !o,
        "mdc-text-field--textarea": s,
        "mdc-text-field--outlined": o,
        "mdc-text-field--invalid": m,
        "mdc-text-field--disabled": F,
        "mdc-text-field--with-leading-icon": !!p,
        "mdc-text-field--with-trailing-icon": !!b,
        "mdc-text-field--no-label": !i,
        "mdc-text-field--end-aligned": a === "end",
        "mdc-text-field--with-internal-counter": s && R,
        "rmwc-text-field--fullwidth": w
      }
    ]), q = (G, k) => /* @__PURE__ */ r(
      ie,
      {
        apiRef: (S) => {
          k === "leading" ? u(S) : C(S);
        },
        position: k,
        tabIndex: k === "trailing" ? 0 : void 0,
        icon: G
      }
    ), re = (G) => {
      if (!(!!h || R && !s))
        return null;
      const S = typeof h == "object" && !A.isValidElement(h);
      return /* @__PURE__ */ v("div", { className: "mdc-text-field-helper-line", children: [
        h && S ? /* @__PURE__ */ r(te, { ...h }) : /* @__PURE__ */ r(te, { children: h }),
        !s && G
      ] });
    }, $ = i ? /* @__PURE__ */ r(
      de,
      {
        shake: P,
        float: j,
        apiRef: T,
        id: Z,
        children: i
      }
    ) : null, B = R ? /* @__PURE__ */ r("div", { className: "mdc-text-field-character-counter", children: E }) : null, le = O ? /* @__PURE__ */ v("span", { className: "mdc-text-field__resizer", children: [
      /* @__PURE__ */ r(
        N,
        {
          ...f,
          element: _,
          className: "mdc-text-field__input",
          disabled: F,
          tag: "textarea",
          ref: J(l, g)
        }
      ),
      B
    ] }) : /* @__PURE__ */ v(V, { children: [
      /* @__PURE__ */ r(
        N,
        {
          ...f,
          element: _,
          className: "mdc-text-field__input",
          disabled: F,
          tag: "textarea",
          ref: J(l, g)
        }
      ),
      B
    ] });
    return /* @__PURE__ */ v(V, { children: [
      /* @__PURE__ */ v(
        Fe,
        {
          ...H,
          element: L,
          style: c,
          className: ae,
          ref: l,
          children: [
            !!p && q(p, "leading"),
            W,
            /* @__PURE__ */ r(ve, {}),
            !!x && !s && /* @__PURE__ */ r(Le, { prefix: x }),
            s ? le : /* @__PURE__ */ r(
              N,
              {
                ...f,
                "aria-labelledby": Z,
                element: _,
                className: "mdc-text-field__input",
                disabled: F,
                tag: "input",
                ref: J(l, g)
              }
            ),
            !!M && !s && /* @__PURE__ */ r(Ce, { suffix: M }),
            o ? /* @__PURE__ */ v(V, { children: [
              /* @__PURE__ */ r(ue, { notch: D, children: $ }),
              !!b && q(b, "trailing")
            ] }) : /* @__PURE__ */ v(V, { children: [
              $,
              !!b && q(b, "trailing"),
              /* @__PURE__ */ r(se, { active: z, center: e })
            ] })
          ]
        }
      ),
      re(B)
    ] });
  }
), ve = A.memo(function() {
  return /* @__PURE__ */ r("span", { className: "mdc-text-field__ripple" });
}), Fe = fe({ surface: !1 })(
  A.forwardRef(function(t, l) {
    return /* @__PURE__ */ r(N, { ...t, tag: "label", ref: l });
  })
), Le = A.memo(function({
  prefix: t
}) {
  return /* @__PURE__ */ r("span", { className: "mdc-text-field__affix mdc-text-field__affix--prefix", children: t });
}), Ce = A.memo(function({
  suffix: t
}) {
  return /* @__PURE__ */ r("span", { className: "mdc-text-field__affix mdc-text-field__affix--suffix", children: t });
}), te = ne(
  function(t, l) {
    const { persistent: i, validationMsg: c, ...o } = t, a = Q(t, [
      "mdc-text-field-helper-text",
      {
        "mdc-text-field-helper-text--persistent": i,
        "mdc-text-field-helper-text--validation-msg": c
      }
    ]);
    return /* @__PURE__ */ r(N, { tag: "div", ...o, className: a, ref: l });
  }
), ie = function(t) {
  const { apiRef: l, position: i, ...c } = t, { rootEl: o } = be(t), a = Q(t, [
    "mdc-text-field__icon",
    {
      "mdc-text-field__icon--trailing": i === "trailing",
      "mdc-text-field__icon--leading": i === "leading"
    }
  ]);
  return /* @__PURE__ */ r(
    ce,
    {
      ...o.props({
        ...c,
        className: a
      })
    }
  );
};
ie.displayName = "TextFieldIcon";
export {
  Oe as TextField,
  te as TextFieldHelperText
};
